export const getSplitReviewStatus = (timeevent) => (
  String(timeevent?.splitReview?.status || '').trim().toLowerCase()
);

export const isPendingSplitReview = (timeevent) => (
  getSplitReviewStatus(timeevent) === 'pending'
);
